var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-upload"},[_c('input',{ref:this.ident,class:this.defaultClass,attrs:{"id":this.ident,"name":this.ident,"accept":this.accept,"required":this.isRequired,"multiple":this.multiple,"type":"file"}})])}
var staticRenderFns = []

export { render, staticRenderFns }